function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.945 6.197l.062 1.007-1.037-.123c-3.777-.473-7.077-2.077-9.878-4.77L1.722.973l-.352.987c-.747 2.2-.27 4.523 1.286 6.086.83.864.643.987-.788.473-.498-.164-.934-.288-.976-.226-.145.144.353 2.015.747 2.755.54 1.028 1.64 2.036 2.843 2.632l1.017.473-1.203.02c-1.163 0-1.204.021-1.08.453.416 1.337 2.055 2.755 3.881 3.372l1.287.432-1.121.658a11.85 11.85 0 01-5.561 1.522c-.934.02-1.702.102-1.702.164 0 .206 2.532 1.357 4.005 1.81 4.42 1.336 9.67.76 13.613-1.522 2.801-1.624 5.603-4.853 6.91-7.978.706-1.666 1.411-4.709 1.411-6.169 0-.946.063-1.069 1.225-2.2.684-.658 1.328-1.378 1.452-1.583.208-.39.187-.39-.871-.041-1.764.617-2.013.534-1.142-.39C27.247 2.042 28.014.85 28.014.5c0-.062-.31.041-.664.226-.373.206-1.203.514-1.826.7l-1.12.349-1.017-.679c-.56-.37-1.349-.781-1.764-.904-1.058-.288-2.677-.247-3.632.082-2.593.925-4.233 3.31-4.046 5.922z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 29 24",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgTwitter;